import React, {Component} from 'react';
import { message } from 'antd';
import { map, isEqual } from 'lodash';
import Loader from '../../../../../../Common/Component/Loader';
import BillingInfo from "./BillingInfo";
import ServiceInfo from "./ServiceInfo";
import moment from "moment-timezone";
import { errorHandle } from "../../../../../../Common/errorHandle";

class AddService extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      franchises: {},
      leadData: '',
      currentTab: 0,
      enquiryList: {},
      field_office_uuid: '',
      customer: {}
    }
  }

  UNSAFE_componentWillMount = () => {
    sessionStorage.clear();
  }

  componentDidMount = () => {
    const { customerId } = this.props;
    this.props.resetCheckZipcode();
    this.props.resetPricingCalculator();
    this.onClearStorage();
    this.props.getCustomerDetail(customerId); // get customer Detail
    this.props.getServiceOrderEnquiry({user__uuid: customerId, limit: 1}); // get service order enquiry
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    // errors handle /////////////////////////////
    if (Object.keys(nextProps?.serviceOrderEnquiry?.errors).length > 0 && nextProps?.serviceOrderEnquiry?.errors !== this.props?.serviceOrderEnquiry?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.serviceOrderEnquiry?.errors)
    }

    if (Object.keys(nextProps?.serviceOrder?.errors).length > 0 && nextProps?.serviceOrderEnquiry?.errors !== this.props?.serviceOrderEnquiry?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.serviceOrderEnquiry?.errors)
    }

    if (Object.keys(nextProps?.customerList?.errors).length > 0 && nextProps?.customerList?.errors !== this.props?.customerList?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.customerList?.errors)
    }

    // get service order enquiry
    if (Object.keys(nextProps?.serviceOrderEnquiry?.enquiryList).length > 0
      && JSON.stringify(nextProps?.serviceOrderEnquiry?.enquiryList) !== JSON.stringify(this.state.enquiryList)) {
      if (nextProps?.serviceOrderEnquiry?.enquiryList?.results?.[0]?.field_office_uuid) {
        this.props.getFranchiseById(nextProps?.serviceOrderEnquiry?.enquiryList?.results?.[0]?.field_office_uuid)
        this.props.getFieldOfficeById({
          zip_code : nextProps?.serviceOrderEnquiry?.enquiryList?.results?.[0]?.service_address?.zip_code,
          franchises_uuid : nextProps?.serviceOrderEnquiry?.enquiryList?.results?.[0]?.field_office_uuid
        })
      }
      this.setState({loader: false, enquiryList: nextProps?.serviceOrderEnquiry?.enquiryList, field_office_uuid: nextProps?.serviceOrderEnquiry?.enquiryList?.results?.[0]?.field_office_uuid}, () => this.priceCalc());
    }

    // get franchise detail
    if (Object.keys(nextProps?.zipcodeCheck?.fieldOfficeDetail).length > 0
      && JSON.stringify(nextProps?.zipcodeCheck?.fieldOfficeDetail) !== JSON.stringify(this.state.franchises)) {
      this.setState({ loader: false, franchises: nextProps?.zipcodeCheck?.fieldOfficeDetail });
    }

    // get customer detail
    if (Object.keys(nextProps?.customerList?.customer).length > 0
      && JSON.stringify(nextProps?.customerList?.customer) !== JSON.stringify(this.state.customer)) {
      if (nextProps?.customerList?.customer?.field_office?.uuid) {
        this.props.getFranchiseById(nextProps?.customerList?.customer?.field_office?.uuid)
        this.props.getFieldOfficeById({
          zip_code : nextProps?.customerList?.customer?.address[0].zip_code,
          franchises_uuid : nextProps?.customerList?.customer?.field_office?.uuid
        })
      }
      this.setState({ loader: false, customer: nextProps?.customerList?.customer, field_office_uuid: nextProps?.customerList?.customer?.field_office?.uuid });
    }

    // add service order
    if (Object.keys(nextProps?.serviceOrder?.addOrder).length > 0
      && JSON.stringify(nextProps?.serviceOrder?.addOrder) !== JSON.stringify(this.props?.serviceOrder?.addOrder)) {
      this.setState({loader: false, addOrder: nextProps?.serviceOrder?.addOrder});
      this.onClearStorage();
      this.props.rerender();
      // this.props.getServiceOrder({ user__uuid: this.props.customerId }) // get service orders
      this.props.onChangeView(0)
    }

    // update service order enquiry
    if (Object.keys(nextProps?.serviceOrderEnquiry?.updateEnquiry).length > 0
      && JSON.stringify(nextProps?.serviceOrderEnquiry?.updateEnquiry) !== JSON.stringify(this.props?.serviceOrder?.updateEnquiry)) {
      this.setState({loader: false});
      this.onClearStorage();
      this.props.rerender();
      
      // this.props.getServiceOrder({ user__uuid: this.props.customerId }) // get service orders
      this.props.getServiceOrderEnquiry({ user__uuid: this.props.customerId }) // get service orders enquiry
      this.props.onChangeView(0)
    }
    this.setState({loader: false})
  }

  // clear storage
  onClearStorage = () => {
    sessionStorage.removeItem('step1');
    sessionStorage.removeItem('step2');
    sessionStorage.removeItem('calcData');
    sessionStorage.removeItem('pricingCalc');
  }

  // on tab change
  onTabChange = (value) => {
    this.setState({currentTab: value})
  };

  // on convert to customer
  onSave = () => {
    const { field_office_uuid, customer, enquiryList } = this.state;
    const { PricingCalc, customerId, isEditEnquiry } = this.props;
    const step1Data = JSON.parse(sessionStorage.getItem('step1'));
    const step2Data = JSON.parse(sessionStorage.getItem('step2'));
    const calcData = JSON.parse(sessionStorage.getItem('calcData'));
    
    if (field_office_uuid) {
      this.setState({loader: true});
      const service_add_ons = []
      map(step1Data?.add_ons, obj => {
        if (obj?.uuid) service_add_ons.push({add_on_uuid: obj?.add_on_uuid, add_on_name: obj?.name, is_recurring: obj?.is_recurring || false})
      });

      const isBillingAddress = isEqual(customer?.address?.[0]?.formatted_address, step2Data?.address?.formatted_address)

      if (!customer?.address?.[0]?.geo_location) {
        delete customer?.address?.[0]?.geo_location
      }

      if (!step2Data?.address?.geo_location) {
        delete step2Data?.address?.geo_location
      }

      let area_to_clean = [];

      if (step1Data?.areaClean && step1Data?.areaClean.length > 0) {
        area_to_clean = step1Data?.areaClean;
        const idx = area_to_clean.indexOf("");
        
        if (idx > -1) {
          area_to_clean[idx] = step1Data?.otherCleaning;
        }
      }

      let obj = {
        first_name: customer?.first_name,
        email: customer?.email,
        phone_numbers: customer?.phone_numbers,
        field_office_uuid: field_office_uuid,
        service_type: 'residential',
        property_type: step1Data?.propertyType ? step1Data?.propertyType : null,
        service_add_ons,
        pets: [],
        area_to_clean: area_to_clean,
        last_cleaned: step1Data?.lastCleaned,
        service_address: customer?.address?.[0],
        disposal_location: step1Data?.disposalLocation,
        cleaning_notes: step1Data?.cleaningNotes,
        preferred_start_date: step2Data?.preferred_start_date ? moment(step2Data?.preferred_start_date).format('YYYY-MM-DD') : null,
        is_billing_address_same: isBillingAddress,
        //<DOOD-2822>Ritesh: uncomment the code to fix </DOOD-2822>
        billing_address: (step2Data?.address?.street_number && step2Data?.address?.route) ? {...step2Data?.address, address: `${step2Data?.address?.street_number} ${step2Data?.address?.route}`} : step2Data?.address,
        //<DOOD-2822>Ritesh: uncomment the code to fix </DOOD-2822>
        ...(step2Data?.user_billing_info_uuid ? {user_billing_info_uuid: step2Data?.user_billing_info_uuid} : {}),
        preferred_contact_methods: step2Data?.contactUs,
        calculated_price: PricingCalc?.data ? {...PricingCalc?.data, charge_initial_clean: step2Data.is_initial_clean} : null,
        coupon_code: calcData?.coupon_code ? calcData?.coupon_code : '',
        is_enquiry: false,
        user: customer,
        user_uuid: customerId,
        is_prepaid: enquiryList?.results[0]?.is_prepaid || PricingCalc?.data?.is_prepaid,
        prepay_months: enquiryList?.results[0]?.prepay_months || PricingCalc?.data?.prepay_months,
        //<DP-3309>Mildred: Add if are the termns accepted
        is_ternm_accepted: step2Data.isAgreed,
        charge_initial_clean: step2Data.is_initial_clean
      }

      if (step1Data?.frequency) {
        Object.assign(obj, {frequency: step1Data?.frequency})
      }
      if (step1Data?.is_extra_pet || step1Data?.dogCount) {
        const pet_count = step1Data?.is_extra_pet ? step1Data?.extra_pet : step1Data?.dogCount;
        let pets = [];
        for (let i = 0; i < pet_count; i++) {
          pets.push({
            name: '',
            breed: '',
            birthday: null,
            is_friendly: false,
            can_treat: false,
            additional_info: '',
            photo: ''
          });
          if (enquiryList && enquiryList?.count > 0) {
            pets[i]['uuid'] = enquiryList?.results[0]?.pets[i]?.uuid;
          }
        }
        Object.assign(obj, {pet_count, pets})
      }
      if (customer?.last_name) {
        Object.assign(obj, {last_name: customer?.last_name})
      }
      console.warn('Add Service', obj);
      if (isEditEnquiry) {
        // after add new customer first time its call
        this.props.updateServiceOrderEnquiry({...obj, uuid: enquiryList?.results?.[0]?.uuid})
      } else {
        //add service order
        this.props.addServiceOrder(obj)
      }
    }
  }

  // common Price Calc
  priceCalc = (extraData = {}) => {
    const {field_office_uuid} = this.state;
    const step1Data = JSON.parse(sessionStorage.getItem('step1'));
    const calcData = JSON.parse(sessionStorage.getItem('calcData'));
    const {dogCount, frequency, areaClean, propertyType, lastCleaned, add_ons, extra_pet, is_extra_pet} = step1Data || {};
    const {coupon_code = '', isPrePay = false, prepay_months = null, is_initial_clean = true} = extraData || {};
    const service_add_ons = []
    map(add_ons, obj => {
      if (obj?.uuid) service_add_ons.push({uuid: obj?.add_on_uuid, add_on_name: obj?.name, is_recurring: obj?.is_recurring || false})
    });
    if (field_office_uuid && frequency && (dogCount || is_extra_pet) && propertyType) {
      this.setState({loader: true})
      const data = {
        'field_office_uuid': field_office_uuid,
        'frequency': frequency,
        'pet_count': is_extra_pet ? extra_pet : dogCount,
        'last_cleaned': lastCleaned,
        'property_type': propertyType,
        'areas_to_clean': areaClean,
        'add_ons': service_add_ons,
        'is_prepaid': isPrePay,
        'prepay_months': isPrePay ? prepay_months : null,
        'charge_initial_clean': is_initial_clean
      }

      if (coupon_code || calcData?.coupon_code) Object.assign(data, {'coupon_code': coupon_code ? coupon_code : calcData?.coupon_code});
      this.props.pricingCalculator(data)
    }
  }

  // add non serviceable enquiry
  onNonServiceableEnquiry = () => {
    const data = JSON.parse(sessionStorage.getItem('basicDetail'))
    let email = data?.emails?.find((x) => x.primary)

    if (email?.email && data?.zipcode) {
      this.setState({loader: true})
      setTimeout(() => {
        this.props.addNonServiceableEnquiry({email: email?.email, zip_code: data?.zipcode})
      }, 1000)
    }
  }

  renderTabs = () => {
    // console.warn('this.state', this.state);
    // console.warn('this.props', this.props);
    const {currentTab} = this.state;
    switch (currentTab) {
    case 0:
      return (<ServiceInfo 
        customerId={this.props.customerId}
        onTabChange={this.onTabChange}
        history={this.props.history}
        onChangeView={this.props.onChangeView} // for change parent view
        currentTab={currentTab}
        isEditEnquiry={true}
        //reducer
        zipcodeCheck={this.props.zipcodeCheck}
        serviceOrderEnquiry={this.props.serviceOrderEnquiry}
        customerList={this.props.customerList}
        PricingCalc={this.props.PricingCalc}
        Service={this.props.Service}
        //api
        getFieldOfficeById={this.props.getFieldOfficeById}
        onNonServiceableEnquiry={this.onNonServiceableEnquiry}
        getCustomerDetail={this.props.getCustomerDetail}
        priceCalc={this.priceCalc}
        // getServiceOrderEnquiry={this.props.getServiceOrderEnquiry}
        checkZipCode={this.props.checkZipCode}
        resetCheckZipcode={this.props.resetCheckZipcode}
      />
      )
    case 1:
      return (
        <BillingInfo
          customerId={this.props.customerId}
          onTabChange={this.onTabChange}
          history={this.props.history}
          onChangeView={this.props.onChangeView} // for change parent view
          currentTab={currentTab}
          //reducer
          zipcodeCheck={this.props.zipcodeCheck}
          serviceOrderEnquiry={this.props.serviceOrderEnquiry}
          customerList={this.props.customerList}
          PricingCalc={this.props.PricingCalc}
          AddCard={this.props.AddCard}
          CardList={this.props.CardList}
          fieldTechnicianFilter={this.props.fieldTechnicianFilter}
          //api
          getFieldOfficeById={this.props.getFieldOfficeById}
          onNonServiceableEnquiry={this.onNonServiceableEnquiry}
          getCustomerDetail={this.props.getCustomerDetail}
          addNewCard={this.props.addNewCard}
          priceCalc={this.priceCalc}
          onSave={this.onSave}
          getCardList={this.props.getCardList}
          deleteCard={this.props.deleteCard}
          // getFieldTechnicianFilter={this.props.getFieldTechnicianFilter}
        />
      )
    default:
      return (<ServiceInfo
        customerId={this.props.customerId}
        onTabChange={this.onTabChange}
        history={this.props.history}
        onChangeView={this.props.onChangeView} // for change parent view
        currentTab={currentTab}
        isEditEnquiry={true}
        //reducer
        zipcodeCheck={this.props.zipcodeCheck}
        serviceOrderEnquiry={this.props.serviceOrderEnquiry}
        customerList={this.props.customerList}
        PricingCalc={this.props.PricingCalc}
        //api
        getFieldOfficeById={this.props.getFieldOfficeById}
        onNonServiceableEnquiry={this.onNonServiceableEnquiry}
        getCustomerDetail={this.props.getCustomerDetail}
        priceCalc={this.priceCalc}
        // getServiceOrderEnquiry={this.props.getServiceOrderEnquiry}
        checkZipCode={this.props.checkZipCode}
        resetCheckZipcode={this.props.resetCheckZipcode}
      />)
    }
  };
  
  render() {
    const {loader} = this.state;

    return (
      <div id="wrapper">
        <div className="fluid">
          {loader && <Loader />}
          {this.renderTabs()}
        </div>
      </div>
    )
  }
}

export default AddService;